var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelperViewContextual',_vm._b({staticClass:"orders-table__helper",on:{"click":_vm.emitOnClearFilters}},'HelperViewContextual',_vm.emptyStateHelperViewProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }